import wishlistItemApi from '@/api/wishlistItem';
import { loadEntity } from '@/helpers/utility';

const state = {
    byId: {},

    statuses: {
        active: 'Active',
        on_hold: 'On Hold',
        archived: 'Archived',
    },

    archiveReasons: {
        canceled: 'Canceled',
        expired: 'Expired',
        reshelved_without_communication: 'Reshelved (no communication)',
        reshelved_with_communication: 'Reshelved (with communication)',
        picked_up: 'Picked Up',
    },
};

const getters = {
};

const actions = {
    async getWishlistItems(store, options) {
        if (options && !options.page)
            options.page = 1;
        let response = await wishlistItemApi.list(options);
        let wishlistItems = response.data;
        let ids = loadEntity({ wishlistItems });
        return { ids, meta: response.meta };
    },
    async findWishlistItem({ dispatch }, { id, code }) {
        let wishlistItem = null;
        if (id)
            wishlistItem = (await wishlistItemApi.get(id)).data;
        else
            wishlistItem = (await wishlistItemApi.find(code)).data;
        loadEntity({ wishlistItem });
        return wishlistItem;
    },
    async createWishlistItem({ dispatch }, { wishlistItem }) {
        wishlistItem = (await wishlistItemApi.create(wishlistItem)).data;
        loadEntity({ wishlistItem });
        return wishlistItem;
    },
    async createMultipleWishlistItems({ dispatch }, { wishlistItem }) {
        let wishlistItems = (await wishlistItemApi.createMultiple(wishlistItem)).data;
        loadEntity({ wishlistItems });
        return wishlistItems;
    },
    async updateWishlistItem({ dispatch }, { wishlistItem }) {
        wishlistItem = (await wishlistItemApi.update(wishlistItem)).data;
        loadEntity({ wishlistItem });
        return wishlistItem;
    },
    async updateWishlistItemStatus({ dispatch }, { wishlistItem }) {
        wishlistItem = (await wishlistItemApi.updateStatus(wishlistItem)).data;
        loadEntity({ wishlistItem });
        return wishlistItem;
    },
    async updateWishlistItemPhoneCallStatus({ dispatch }, { wishlistItem }) {
        wishlistItem = (await wishlistItemApi.updatePhoneCallStatus(wishlistItem)).data;
        loadEntity({ wishlistItem });
        return wishlistItem;
    },
    async updateWishlistItemTextMessageStatus({ dispatch }, { wishlistItem }) {
        wishlistItem = (await wishlistItemApi.updateTextMessageStatus(wishlistItem)).data;
        loadEntity({ wishlistItem });
        return wishlistItem;
    },
    async deleteWishlistItem({ commit }, { wishlistItem }) {
        let response = await wishlistItemApi.delete(wishlistItem);
        commit('REMOVE_WISHLISTITEM', { response });
        return response;
    },
};

const mutations = {
    LOAD_ENTITIES(state, { wishlistItems }) {
        if (wishlistItems)
            Object.values(wishlistItems).forEach(wishlistItem => Vue.set(state.byId, wishlistItem.id, wishlistItem));
    },
    REMOVE_WISHLISTITEM(state, { response }) {
        Vue.delete(state.byId, response.id);
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
